import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.scss";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PatientInfo from "./Components/CBSFormSections/PatientInfo";
import AutoAccident from "./Components/CBSFormSections/AutoAccident";
import AutoAccidentInfo from "./Components/CBSFormSections/AutoAccidentInfo";
import OtherAccidentInfo from "./Components/CBSFormSections/OtherAccidentInfo";
import Attorney from "./Components/CBSFormSections/Attorney";
import Authorization from "./Components/CBSFormSections/Authorization";
import Header from "./Components/CBSFormSections/Header";
import OtherDriversInsurance from "./Components/CBSFormSections/OtherDriversInsurance";
import { uniqId, getFormattedDate } from "./utils/commonHelpers";
import PrimaryField from "./Components/CBSFormSections/PrimaryField";
import WorkRelatedInfo from "./Components/CBSFormSections/WorkRelated";
import Employer from "./Components/CBSFormSections/Employer";
import { CircularProgress, Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CBSLOGO from "./cbs-logo-1.png";
import GetAppIcon from "@material-ui/icons/GetApp";
import ErrorFocus from "./Components/FormComponents/ErrorFocus";
import moment from "moment";
import endOfDay from "date-fns/endOfDay"
import AlertBox from "./utils/Alert";
import Signature from "./Components/Signature";
import PreForm from "./Components/CBSFormSections/PreForm";

var _ = require("lodash");

const url = process.env.REACT_APP_API_URL;
// Testing SSN Number
const ssnRegex = new RegExp("^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$");
// Testing Phone Number
const phoneRegex = new RegExp(/\d/g);


const initialvalues = {
  reportedToResponsiblePerson: "No",
  isClaimRaised: "No",
  patient: {
    patientFirstName: "",
    patientMiddleName: "",
    patientLastName: "",
    addressLine1: "",
    cellPhoneConsent: true,
    dateOfBirth: null,
    email: "",
    city: "",
    state: "",
    zip: "",
    emailConsent: true,
    healthCareProvider: "",
    landPhone: "",
    serviceDate: null,
    ssn: "",
    facsNumber: "",
    accidentDate: null,
    accidentType: ["Auto"],
    otherAccidentReason: "",
  },
  workRelated: {
    insuranceCarrier: "",
    addressLine1: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    claim: "",
    adjusterName: "",
    adjusterPhone: "",
    adjusterEmail: "",
  },
  employer: {
    accidentType: ["Auto"],
    employerName: "",
    employerAddressLine1: "",
    employerLandPhone: "",
    employerCity: "",
    employerState: "",
    employerZipCode: "",
  },
  accident: {
    accidentType: ["Auto"],
    addressLine1: "",
    city: "",
    claimNo: "",
    // date: null, removeda as per becky feedback
    description: "",
    insurerAddressLine1: "",
    insurerCity: "",
    insurerName: "",
    insurerState: "",
    insurerZipCode: "",
    insurerPhone: "",
    isClaimRaised: "",
    location: [],
    phone: "",
    reportedToResponsiblePerson: "",
    responsibility: "",
    responsiblePersonName: "",
    state: "",
    zipCode: "",
  },
  autoInsurance: {
    id: uniqId(),
    addressLine1: "",
    adjuster: "",
    city: "",
    claimNo: "",
    insuredType: "Self",
    policyHolderName: "",
    nameOfCarrier: "",
    phone: "",
    // insurerName: "",
    policyNo: "",
    state: "",
    zipCode: "",
    accidentType: ["Auto"],
  },
  autoAccident: {
    autoInsurances: [{}],
    isDriver: "",
    noOfVehicles: "",
    responsiblePerson: "",
    accidentType: ["Auto"],
  },
  otherDriverInsuranceFields: [
    {
      id: uniqId(),
      insuredType: "Other",
      policyHolderName: "",
      nameOfCarrier: "",
      insurerName: "",
      policyNo: "",
      claimNo: "",
      adjuster: "",
      phone: "",
      addressLine1: "",
      city: "",
      state: "",
      zipCode: "",
    },
  ],
  healthInsurances: [
    {
      id: uniqId(),
      insurerName: "",
      addressLine1: "",
      policyHolderDateOfBirth: null,
      policyHolderName: "",
      city: "",
      state: "",
      zipCode: "",
      patientRelationship: "",
      phone: "",
      policyNo: "",
      groupId: "",
    },
  ],
  primaryHealth: "No",
  attorney: {
    isAttorney: "No",
    addressLine1: "",
    city: "",
    name: "",
    phone: "",
    state: "",
    zipCode: "",
  },
  authorization: {
    date: new Date(),
    name: "",
    phone: "",
    relationship: "",
    signature: "",
    isItalicSign: false,
    italicSign: ""
  },
};

export default function CBS() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [primaryHealth, setPrimaryHealth] = useState("No");
  const [preForm, setPreForm] = useState(true);

  const [preFormDetails, setPreFormDetails] = useState({
    patientFirstName: "",
    patientMiddleName: "",
    patientLastName: "",
    email: "",
    landPhone: "",
  })

  const handlePreFormDetails = (data) => {
    setPreFormDetails({...data});
  }

  // useEffect(() => {
    const {patientFirstName,patientMiddleName,patientLastName,email,landPhone, patientId} = preFormDetails;
    initialvalues.patient.patientFirstName = patientFirstName;
    initialvalues.patient.patientMiddleName = patientMiddleName;
    initialvalues.patient.patientLastName = patientLastName;
    initialvalues.patient.email = email;
    initialvalues.patient.landPhone = landPhone;
    initialvalues.patient.externalId = patientId;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [preFormDetails]);

  const schema = Yup.object().shape({
    // Validations for Patien Info Start
    patient: Yup.object().shape(
      {
        patientFirstName: Yup.string().trim().required("Patient First Name is required"),
        patientLastName: Yup.string().trim().required("Patient Last Name is required"),
        email: Yup.string().email("Must be a valid Email").required("Email is required"),
        landPhone: Yup.string()
          .trim()
          .required("Phone Number is required")
          .transform((value) => value.replace(/[^\d]/g, ""))
          .min(10, "Must be exactly 10 digits")
          .max(10, "Must be exactly 10 digits"),
        serviceDate: Yup.date()
          .typeError("Please enter a valid date")
          .max(endOfDay(new Date()), "Must be a date in the past")
          .min(moment(new Date(1870, 1, 1)).toDate(), "Date must be greater than 1870")
          .nullable(),
        dateOfBirth: Yup.date()
          .typeError("Please enter a valid date")
          .max(endOfDay(new Date()), "Must be a date in the past")
          .min(moment(new Date(1870, 1, 1)).toDate(), "Date must be greater than 1870")
          .required("Date of Birth is required")
          .nullable(),
        addressLine1: Yup.string().trim().required("Address is required"),
        accidentDate: Yup.date()
          .typeError("Please enter a valid date")
          .min(Yup.ref("dateOfBirth"), "Date of Accident must not be earlier than Date of Birth")
          .max(endOfDay(new Date()), "Must be a date in the past")
          .required("Date of Accident is required")
          .nullable(),
        accidentType: Yup.array().min(1).required("At least one type is required"),
        city: Yup.string().trim().required("City is required"),
        state: Yup.string().trim().required("State is required"),
        ssn: Yup.string().test("ssnTest", "Enter a valid Social Security Number", (value) => {
          if (value) {
            let val = value.replace(/[\uFF3F\uFF3F\uFF3F-\uFF3F\uFF3F-\uFF3F\uFF3F\uFF3F\uFF3F]/g, "");
            let val1 = val.replaceAll("-", "");
            if (val1.length === 0) {
              return true;
            } else {
              return ssnRegex.test(value);
            }
          }
          return true;
        }),
        // .matches(ssnRegex, "Enter a valid Social Security Number"),
        zip: Yup.string()
          .required("ZIP Code is required")
          .matches(/^[0-9]+$/, "Must be only digits")
          .min(5, "Must be exactly 5 digits")
          .max(5, "Must be exactly 5 digits"),
        otherAccidentReason: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Other"),
          then: Yup.string().trim().required("Other Reason for accident is required"),
          otherwise: Yup.string().trim(),
        }),
      },
      [["accidentType"]]
    ),
    // Validations for Patien Info End

    // Validations for Employer Info Start
    employer: Yup.object().shape(
      {
        accidentType: Yup.array(),
        employerName: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Work Related"),
          then: Yup.string().trim().required("Employer Name is required"),
          otherwise: Yup.string(),
        }),
        employerLandPhone: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Work Related"),
          then: Yup.string()
            .required("Phone Number is required")
            .transform((value) => value.replace(/[^\d]/g, ""))
            .min(10, "Must be exactly 10 digits")
            .max(10, "Must be exactly 10 digits"),
          otherwise: Yup.string(),
        }),
        employerAddressLine1: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Work Related"),
          then: Yup.string().trim().required("Address is required"),
          otherwise: Yup.string(),
        }),
        employerState: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Work Related"),
          then: Yup.string().trim().required("State is required"),
          otherwise: Yup.string(),
        }),
        employerCity: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Work Related"),
          then: Yup.string().trim().required("City is required"),
          otherwise: Yup.string(),
        }),
        employerZipCode: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Work Related"),
          then: Yup.string()
            .required("ZIP Code is required")
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
          otherwise: Yup.string(),
        }),
      },
      [["accidentType"]]
    ),
    // Validations for Employer Info End

    // Validations for Accident Start
    accident: Yup.object().shape(
      {
        accidentType: Yup.array(),
        description: Yup.string().when("accidentType", {
          is: (accidentType) =>
            accidentType.includes("Slip and Fall") ||
            accidentType.includes("Crime Related") ||
            accidentType.includes("Dog Bite") ||
            accidentType.includes("Other"),
          then: Yup.string().trim().required("Accident description is required"),
          otherwise: Yup.string(),
        }),
        responsibility: Yup.string().when("accidentType", {
          is: (accidentType) =>
            accidentType.includes("Slip and Fall") ||
            accidentType.includes("Crime Related") ||
            accidentType.includes("Dog Bite") ||
            accidentType.includes("Other"),
          then: Yup.string().trim().required("Responsible party's name is required"),
          otherwise: Yup.string(),
        }),
        insurerZipCode: Yup.string()
          .matches(/^[0-9]+$/, "Must be only digits")
          .min(5, "Must be exactly 5 digits")
          .max(5, "Must be exactly 5 digits"),
        insurerPhone: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
          if (value) {
            value = value.replace(/[^\d]/g, "");
            return value.length === 10 || value.length === 0;
          }
          return true;
        }),
        // .transform((value) => value.replace(/[^\d]/g, ""))
        // .min(10, "Must be exactly 10 digits")
        // .max(10, "Must be exactly 10 digits"),
        // date: Yup.date().when("accidentType", { // not needed
        //   is: (accidentType) =>
        //     accidentType.includes("Slip and Fall") ||
        //     accidentType.includes("Crime Related") ||
        //     accidentType.includes("Dog Bite") ||
        //     accidentType.includes("Other"),
        //   then: Yup.date()
        //     .typeError("Please enter a valid date")
        //     .max(new Date(), "Must be a date in the past")
        //     .required("Date of Accident is required")
        //     .nullable(),
        //   otherwise: Yup.date().nullable(),
        // }),

        location: Yup.array().when("accidentType", {
          is: (accidentType) =>
            accidentType.includes("Slip and Fall") ||
            accidentType.includes("Crime Related") ||
            accidentType.includes("Dog Bite") ||
            accidentType.includes("Other"),
          then: Yup.array().min(1).required("At least one location is required"),
          otherwise: Yup.array(),
        }),

        reportedToResponsiblePerson: Yup.string().when("accidentType", {
          is: (accidentType) =>
            accidentType.includes("Slip and Fall") ||
            accidentType.includes("Crime Related") ||
            accidentType.includes("Dog Bite") ||
            accidentType.includes("Other"),
          then: Yup.string().trim().required("At least one must be selected"),
          otherwise: Yup.string(),
        }),

        responsiblePersonName: Yup.string().when("reportedToResponsiblePerson", {
          is: (reportedToResponsiblePerson) => reportedToResponsiblePerson === "Yes",
          then: Yup.string().trim().required("Responsible party's name is required"),
          otherwise: Yup.string(),
        }),

        addressLine1: Yup.string().when("reportedToResponsiblePerson", {
          is: (reportedToResponsiblePerson) => reportedToResponsiblePerson === "Yes",
          then: Yup.string().trim().required("Address is required"),
          otherwise: Yup.string(),
        }),
        phone: Yup.string().when("reportedToResponsiblePerson", {
          is: (reportedToResponsiblePerson) => reportedToResponsiblePerson === "Yes",
          then: Yup.string()
            .required("Phone Number is required")
            .transform((value) => value.replace(/[^\d]/g, ""))
            .min(10, "Must be exactly 10 digits")
            .max(10, "Must be exactly 10 digits"),
          otherwise: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
            if (value) {
              value = value.replace(/[^\d]/g, "");
              return value.length === 10 || value.length === 0;
            }
            return true;
          }),
        }),
        city: Yup.string().when("reportedToResponsiblePerson", {
          is: (reportedToResponsiblePerson) => reportedToResponsiblePerson === "Yes",
          then: Yup.string().trim().required("City is required"),
          otherwise: Yup.string(),
        }),
        state: Yup.string().when("reportedToResponsiblePerson", {
          is: (reportedToResponsiblePerson) => reportedToResponsiblePerson === "Yes",
          then: Yup.string().trim().required("State is required"),
          otherwise: Yup.string(),
        }),
        zipCode: Yup.string().when("reportedToResponsiblePerson", {
          is: (reportedToResponsiblePerson) => reportedToResponsiblePerson === "Yes",
          then: Yup.string()
            .required("ZIP Code is required")
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
          otherwise: Yup.string()
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
        }),

        isClaimRaised: Yup.string().when("accidentType", {
          is: (accidentType) =>
            accidentType.includes("Slip and Fall") ||
            accidentType.includes("Crime Related") ||
            accidentType.includes("Dog Bite") ||
            accidentType.includes("Other"),
          then: Yup.string().required("At least one must be selected"),
          otherwise: Yup.string(),
        }),
      },
      [["accidentType"]]
    ),
    // Validations for Accident End

    // Validations for Auto accident Start
    autoAccident: Yup.object().shape(
      {
        accidentType: Yup.array(),
        noOfVehicles: Yup.number().when("accidentType", {
          is: (accidentType) => accidentType.includes("Auto"),
          then: Yup.number("Must be number")
            .required("Number of vehicles are required")
            .positive()
            .integer()
            .min(1, "Minimum of 1 vehicle is required")
            .max(100, "Maximum of 100 vehicles are allowed"),
        }),

        responsiblePerson: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Auto"),
          then: Yup.string().trim().required("Responsible party's name is required"),
          otherwise: Yup.string(),
        }),
        isDriver: Yup.string().when("accidentType", {
          is: (accidentType) => accidentType.includes("Auto"),
          then: Yup.string().required("At least one must be selected"),
          otherwise: Yup.string(),
        }),
      },
      [["accidentType"]]
    ),

    // Validations for Your auto insurance in Auto accident
    autoInsurance: Yup.object().shape({
      accidentType: Yup.array(),
      phone: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
        if (value) {
          value = value.replace(/[^\d]/g, "");
          return value.length === 10 || value.length === 0;
        }
        return true;
      }),
      // .transform((value) => value.replace(/[^\d]/g, ""))
      // .min(10, "Must be exactly 10 digits")
      // .max(10, "Must be exactly 10 digits"),
      zipCode: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(5, "Must be exactly 5 digits")
        .max(5, "Must be exactly 5 digits"),
      // nameOfCarrier: Yup.string().when("accidentType", {
      //   is: (accidentType) => accidentType.includes("Auto"),
      //   then: Yup.string().required("Name of Carrier is required"),
      //   otherwise: Yup.string(),
      // }),
      // policyNo: Yup.string().when("accidentType", {
      //   is: (accidentType) => accidentType.includes("Auto"),
      //   then: Yup.string().required("Policy is required"),
      //   otherwise: Yup.string(),
      // }),
    }),

    // Validations for Other Drivers auto insurance in Auto accident
    otherDriverInsuranceFields: Yup.array()
      .of(
        Yup.object().shape({
          phone: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
            if (value) {
              value = value.replace(/[^\d]/g, "");

              return value.length === 10 || value.length === 0;
            }
            return true;
          }),
          // .transform((value) => value.replace(/[^\d]/g, ""))
          // .min(10, "Must be exactly 10 digits")
          // .max(10, "Must be exactly 10 digits"),
          zipCode: Yup.string()
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
        })
      )
      .max(4, "Maximum of 4 insurances are allowed"),
    // Validations for Auto accident End

    // Validations for Health insurance start
    healthInsurances: Yup.array()
      .of(
        Yup.object().shape({
          zipCode: Yup.string()
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),

          phone: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
            if (value) {
              value = value.replace(/[^\d]/g, "");

              return value.length === 10 || value.length === 0;
            }
            return true;
          }),
          // .transform((value) => value.replace(/[^\d]/g, ""))
          // .min(10, "Must be exactly 10 digits")
          // .max(10, "Must be exactly 10 digits"),

          policyNo: Yup.string().when("dummy", {
            is: (val) => primaryHealth === "Yes",
            then: Yup.string().required("Member ID is required"),
            otherwise: Yup.string(),
          }),

          insurerName: Yup.string().when("dummy", {
            is: (val) => primaryHealth === "Yes",
            then: Yup.string().required("Insurance Name is required"),
            otherwise: Yup.string(),
          }),

          policyHolderName: Yup.string().when("dummy", {
            is: (val) => primaryHealth === "Yes",
            then: Yup.string().trim().required("Policyholder Name is required"),
            otherwise: Yup.string(),
          }),

          policyHolderDateOfBirth: Yup.date().when("dummy", {
            is: (val) => primaryHealth === "Yes",
            then: Yup.date()
              .typeError("Please enter a valid date")
              .required("Policyholder Date of Birth is required")
              .max(endOfDay(new Date()), "Must be a date in the past")
              .min(moment(new Date(1870, 1, 1)).toDate(), "Date must be greater than 1870")
              .nullable(),
            otherwise: Yup.date()
              .typeError("Please enter a valid date")
              .max(endOfDay(new Date()), "Must be a date in the past")
              .min(moment(new Date(1870, 1, 1)).toDate(), "Date must be greater than 1870")
              .nullable(),
          }),
        })
      )
      .max(4, "Maximum of 4 insurances are allowed"),
    // Validations for Health insurance end

    // Validations for Work Related
    workRelated: Yup.object().shape({
      adjusterEmail: Yup.string().email("Must be a valid Email"),
      phone: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
        if (value) {
          value = value.replace(/[^\d]/g, "");
          return value.length === 10 || value.length === 0;
        }
        return true;
      }),
      // .transform((value) => value.replace(/[^\d]/g, ""))
      // .min(10, "Must be exactly 10 digits")
      // .max(10, "Must be exactly 10 digits"),
      adjusterPhone: Yup.string().test("phn", "Must be exactly 10 digits", (value) => {
        if (value) {
          value = value.replace(/[^\d]/g, "");
          return value.length === 10 || value.length === 0;
        }
        return true;
      }),
      // .transform((value) => value.replace(/[^\d]/g, ""))
      // .min(10, "Must be exactly 10 digits")
      // .max(10, "Must be exactly 10 digits"),
      zip: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(5, "Must be exactly 5 digits")
        .max(5, "Must be exactly 5 digits"),
    }),

    // Validation for Authorization
    authorization: Yup.object().shape({
      date: Yup.date().required("Date of Authorization is required").nullable(),
      name: Yup.string().trim().required("Name is required"),
      phone: Yup.string()
        .required("Phone Number is required")
        .transform((value) => value.replace(/[^\d]/g, ""))
        .min(10, "Must be exactly 10 digits")
        .max(10, "Must be exactly 10 digits"),
      relationship: Yup.string().trim().required("Relationship to the Patient is required"),
      isItalicSign: Yup.bool(),
      signature: Yup.string().when('isItalicSign', {
        is: (isItalicSign) => !isItalicSign,
        then: Yup.string().required("Signature is required"),
      }),
      italicSign: Yup.string().when('isItalicSign', {
        is: (isItalicSign) => isItalicSign,
        then: Yup.string().required("Signature is required"),
      }),
    }),

    // Validation for Attorney section
    attorney: Yup.object().shape({
      isAttorney: Yup.string(),

      addressLine1: Yup.string().when("isAttorney", {
        is: (isAttorney) => isAttorney === "Yes",
        then: Yup.string().required("Address is required"),
      }),
      city: Yup.string().when("isAttorney", {
        is: (isAttorney) => isAttorney === "Yes",
        then: Yup.string().required("City is required"),
      }),
      name: Yup.string().when("isAttorney", {
        is: (isAttorney) => isAttorney === "Yes",
        then: Yup.string().required("Attorney Name is required"),
      }),
      phone: Yup.string().when("isAttorney", {
        is: (isAttorney) => isAttorney === "Yes",
        then: Yup.string()
          .required("Phone Number is required")
          .transform((value) => value.replace(/[^\d]/g, ""))
          .min(10, "Must be exactly 10 digits")
          .max(10, "Must be exactly 10 digits"),
      }),
      state: Yup.string().when("isAttorney", {
        is: (isAttorney) => isAttorney === "Yes",
        then: Yup.string().required("State is required"),
      }),
      zipCode: Yup.string().when("isAttorney", {
        is: (isAttorney) => isAttorney === "Yes",
        then: Yup.string()
          .required("ZIP Code is required")
          .matches(/^[0-9]+$/, "Must be only digits")
          .min(5, "Must be exactly 5 digits")
          .max(5, "Must be exactly 5 digits"),
      }),
    }),
  });


  const onSubmit = async (values, onSubmitProps) => {
    // Authorization Validation - Submit - Need to send all Fields by default
    const authorization = _.cloneDeep(values.authorization);
    authorization.date = values.authorization.date ? getFormattedDate(values.authorization.date) : "";
    // authorization.isItalicSign = _.isEmpty(values.authorization.italicSign);

    // Patient Validation - Submit - Need to send all Fields by default
    const valPatient = _.cloneDeep(values.patient);
    // valPatient.emailConsent = values.patient.email ? values.patient.emailConsent : false;
    valPatient.dateOfBirth = values.patient.dateOfBirth
      ? getFormattedDate(values.patient.dateOfBirth)
      : "";
    valPatient.accidentDate = values.patient.accidentDate
      ? getFormattedDate(values.patient.accidentDate)
      : "";
    valPatient.serviceDate = values.patient.serviceDate
      ? getFormattedDate(values.patient.serviceDate)
      : "";
    if (!ssnRegex.test(values.patient.ssn)) {
      valPatient.ssn = values.patient.ssn.replaceAll("-", "");
      valPatient.ssn = valPatient.ssn.replaceAll("\uFF3F", "");
    }
    if (!values.patient.accidentType.includes("Other")) {
      valPatient.otherAccidentReason = "";
    }
    delete valPatient.employerAddressLine1;
    delete valPatient.employerCity;
    delete valPatient.employerLandPhone;
    delete valPatient.employerName;
    delete valPatient.employerState;
    delete valPatient.employerZipCode;

    const patient = valPatient;

    // Attorney Validation - Submit - If Attorney is "Yes" then will send values
    let attorney = {};
    if (values.attorney.isAttorney === "Yes") {
      attorney = _.cloneDeep(values.attorney);
      attorney.zip = values.attorney.zipCode;
      attorney.landPhone = values.attorney.phone;
      delete attorney.phone;
      delete attorney.zipCode;
      delete attorney.isAttorney;
    }

    // Auto Section - Submit - If user selects 'Auto' then we'll send values
    let autoAccident = {};
    let autoInsurances = [];

    if (values.patient && values.patient.accidentType && values.patient.accidentType.includes("Auto")) {
      // Auto accident validation
      autoAccident = {
        isDriver: values.autoAccident.isDriver,
        noOfVehicles: values.autoAccident.noOfVehicles,
        responsiblePerson: values.autoAccident.responsiblePerson,
      };
      // Auto accident End
      // Auto Insurance Validation
      const autoInsuranceObj = _.cloneDeep(values.autoInsurance);
      if (!phoneRegex.test(values.autoInsurance.phone)) {
        autoInsuranceObj.phone = autoInsuranceObj.phone.replace(/[^\d]/g, "");
      }
      delete autoInsuranceObj.id;
      delete autoInsuranceObj.accidentType;

      autoInsurances.push(autoInsuranceObj);

      const tempOtherDriversInsurance = _.cloneDeep(values.otherDriverInsuranceFields);
      tempOtherDriversInsurance.forEach((ele) => {
        const otherDriversInsObj = ele;

        if (otherDriversInsObj.phone.includes("\uFF3F")) {
          otherDriversInsObj.phone = "";
        }
        // if (!phoneRegex.test(ele.phone)) {
        //   otherDriversInsObj.phone = otherDriversInsObj.phone.replace(/[^\d]/g, "");
        // }
        delete otherDriversInsObj.id;
        autoInsurances.push(otherDriversInsObj);
      });
      // Auto Insurance End
    }

    // Work Related Submit - If 'Work Related' is checked We'll send fields
    let employer = {};
    let workRelatedVO = {};

    if (
      values.patient &&
      values.patient.accidentType &&
      values.patient.accidentType.includes("Work Related")
    ) {
      //Employer info start
      employer = {
        addressLine1: values.employer.employerAddressLine1,
        city: values.employer.employerCity,
        landPhone: values.employer.employerLandPhone,
        name: values.employer.employerName,
        state: values.employer.employerState,
        zip: values.employer.employerZipCode,
      };

      // Work related Info
      workRelatedVO = _.cloneDeep(values.workRelated);
      if (!phoneRegex.test(values.workRelated.phone)) {
        workRelatedVO.phone = workRelatedVO.phone.replace(/[^\d]/g, "");
      }
      if (!phoneRegex.test(values.workRelated.adjusterPhone)) {
        workRelatedVO.adjusterPhone = workRelatedVO.adjusterPhone.replace(/[^\d]/g, "");
      }
    }

    // Health Insurance Validation - Submit - If Health insurance field is 'yes' then we need to send fields
    let healthInsurances = [];
    if (values.primaryHealth === "Yes") {
      const tempHealthInsurance = _.cloneDeep(values.healthInsurances);

      tempHealthInsurance.forEach((ele, ind) => {
        const obj = ele;
        obj.policyHolderDateOfBirth = ele.policyHolderDateOfBirth
          ? getFormattedDate(ele.policyHolderDateOfBirth)
          : "";
        delete obj.id;

        if (obj.phone.includes("\uFF3F")) {
          obj.phone = "";
        }
        // if (!phoneRegex.test(obj.phone)) {
        //   ele.phone = ele.phone.replace(/[^\d]/g, "");
        // }
        if (ind === 0) {
          obj.insuredType = "Primary";
        } else {
          obj.insuredType = "Other";
        }
        healthInsurances.push(obj);
      });
    }

    // Other Accident Validation - if Other is checked, we are sending the fields otherwise empty fields
    let otherAccident = {};

    let valAccident = _.cloneDeep(values.accident);
    if (!phoneRegex.test(values.accident.insurerPhone)) {
      valAccident.insurerPhone = valAccident.insurerPhone.replace(/[^\d]/g, "");
    }
    if (!phoneRegex.test(values.accident.phone)) {
      valAccident.phone = valAccident.phone.replace(/[^\d]/g, "");
    }

    valAccident.reportedToResponsiblePerson = values.accident.reportedToResponsiblePerson === "Yes";
    valAccident.isClaimRaised = values.accident.isClaimRaised === "Yes";
    delete valAccident.accidentType;

    if (
      (values.patient.accidentType &&
        values.patient.accidentType.length > 0 &&
        values.patient.accidentType.includes("Other")) ||
      values.patient.accidentType.includes("Dog Bite") ||
      values.patient.accidentType.includes("Slip and Fall") ||
      values.patient.accidentType.includes("Crime Related")
    ) {
      otherAccident = valAccident;
    }

    // gathering all data here

    // Default Selections need to go to the API
    const data = {
      patient,
      authorization,
    };

    // If any fields are selected we need to send otherAccident Info
    if (
      (values.patient.accidentType &&
        values.patient.accidentType.length > 0 &&
        values.patient.accidentType.includes("Other")) ||
      values.patient.accidentType.includes("Dog Bite") ||
      values.patient.accidentType.includes("Slip and Fall") ||
      values.patient.accidentType.includes("Crime Related")
    ) {
      data.otherAccident = otherAccident;
    }

    // If health insurance is checked then we need to send Health Insurances
    if (values.primaryHealth === "Yes") {
      data.healthInsurances = healthInsurances;
    }

    // If attorney is checked then we need to send Attorney Info
    if (values.attorney.isAttorney === "Yes") {
      data.attorney = attorney;
    }

    // If work related is checked then we need to send Employer Info and workRelatedVO info
    if (
      values.patient &&
      values.patient.accidentType &&
      values.patient.accidentType.includes("Work Related")
    ) {
      data.employer = employer;
      data.workRelatedVO = workRelatedVO;
    }

    if (values.patient && values.patient.accidentType && values.patient.accidentType.includes("Auto")) {
      data.autoAccident = autoAccident;
      data.autoInsurances = autoInsurances;
    }

    setLoading(true);
    setErrorMessage("");

    await axios
      .post(`${url}/cbsApi/saveForm`, data)
      .then((res) => {
        if (res.status === 200 && res.data.docUrl) {
          setLoading(false);
          setSuccess(true);
          setDownloadLink(res.data.docUrl);
        } else {
          if(res.data&&res.data.message){
            setErrorMessage(res.data.message);
          }
          setLoading(false);
          setError(true);
          onSubmitProps.setSubmitting(false);
        }
      })
      .catch((error) => {
        if (error.data && error.data.message) {
          setErrorMessage(error.data.message);
        }
        setLoading(false);
        setError(true);
        onSubmitProps.setSubmitting(false);
      });
  };

  const handleClose = () => {
    setError(false);
  };
  
  return (
    <div className={loading ? "card custom-card m-5 cbs-form-blur" : "card custom-card m-5"}>
      {success ? (
        <div className="thanks-msg">
          <Header />
          <div className="text-center">
            <p className="thanks-content text-success">
              Thank you for completing the Accident Detail Request Form and uploading it to Complete
              Billing Services. We appreciate your response! We are processing the information you
              provided and are thankful for the opportunity to be of assistance. <br/><br/><span style={{fontWeight: 500}}>The information
              submitted by you can be downloaded as a PDF by clicking the Download button below.</span>
            </p>
            <Button
              href={downloadLink}
              style={{ color: "#fff", background: "#0065a4", marginRight: "30px" }}
              download
              target="_blank"
            >
              Download <GetAppIcon />
            </Button>
            <Button style={{ color: "#0065a4" }} onClick={() => {setSuccess(false); setPreForm(true);}}>
              Go back
            </Button>
          </div>
        </div>
      ) : preForm ?
           <PreForm setPreForm={setPreForm} preFormDetails={preFormDetails} handlePreFormDetails={handlePreFormDetails}/>
        : (
        <Formik initialValues={initialvalues} onSubmit={onSubmit} validationSchema={schema} enableReinitialize>
          {(props) => {
            const { values, errors, isSubmitting} = props;
            return (
              <Form id="cbs-forms" noValidate="noValidate" style={{ padding: "20px 0px 25px" }}>
                <div className="common-input-field">
                  <Header />
                  {/* {console.log("errors", errors)} */}
                  <PatientInfo {...props} />
                  {values.patient &&
                    values.patient.accidentType &&
                    // values.patient.accidentType.length &&
                    values.patient.accidentType.includes("Auto") && (
                      <div className="card custom-card">
                        <AutoAccidentInfo {...props} />
                        <AutoAccident {...props} />
                        <OtherDriversInsurance {...props} />
                      </div>
                    )}
                  {values.patient &&
                  values.patient.accidentType &&
                  // values.patient.accidentType.length &&
                  values.patient.accidentType.includes("Work Related") ? (
                    <React.Fragment>
                      <Employer {...props} />
                      <WorkRelatedInfo {...props} />
                    </React.Fragment>
                  ) : null}
                  <PrimaryField {...props} setPrimaryHealth={setPrimaryHealth} />
                  {(values.patient &&
                    values.patient.accidentType &&
                    values.patient.accidentType.includes("Slip and Fall")) ||
                  values.patient.accidentType.includes("Crime Related") ||
                  values.patient.accidentType.includes("Dog Bite") ||
                  values.patient.accidentType.includes("Other") ? (
                    <React.Fragment>
                      <OtherAccidentInfo {...props} />
                    </React.Fragment>
                  ) : null}
                  <Attorney {...props} />
                  <Authorization {...props} />
                  <div className="row">
                    <div className="mx-auto custom-submit-btn">
                      <button type="submit" disabled={props.isSubmitting}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
                <ErrorFocus />
                <AlertBox errors={errors} isSubmitting={isSubmitting}/>
              </Form>
            );
          }}
        </Formik>
      )}
      {/* end */}
      {/* Start of Error Dialog */}
      <Dialog
        fullWidth={true}
        open={error}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <DialogTitle id="max-width-dialog-title">
            {" "}
            <div className="text-center p-3">
              <img src={CBSLOGO} alt="logo" className="img-fluid" />
            </div>
          </DialogTitle>

          <DialogContentText className="text-center text-danger">
            {errorMessage || "Please try again. We apologize for any inconvenience."}
          </DialogContentText>
          <div className="text-center">
            <Button type="btn" className="btn" onClick={handleClose} color="primary">
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* End of Error Dialog */}
      {/* Start of Loading */}
      {loading && (
        <div className="custom-loader">
          <div className="semiTransparenDiv"></div>
          <CircularProgress />
        </div>
      )}
      {/* End of Loading */}
    </div>
  );
}
